
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 17.333a8.067 8.067 0 01-3.229-.656 8.533 8.533 0 01-2.656-1.781 8.32 8.32 0 01-1.792-2.646A8.118 8.118 0 01.667 9c0-1.153.219-2.236.656-3.25a8.32 8.32 0 011.792-2.646 8.533 8.533 0 012.656-1.781A8.066 8.066 0 019 .667a8.17 8.17 0 013.271.656 8.412 8.412 0 012.646 1.781c.75.75 1.34 1.632 1.771 2.646A8.238 8.238 0 0117.333 9a8.237 8.237 0 01-.645 3.25 8.275 8.275 0 01-1.771 2.646 8.41 8.41 0 01-2.646 1.781A8.17 8.17 0 019 17.333zm-.833-6.562h1.625c0-.473.052-.837.156-1.094.104-.257.399-.621.885-1.094.347-.347.625-.684.834-1.01.208-.327.312-.719.312-1.177 0-.778-.281-1.375-.844-1.792-.562-.417-1.239-.625-2.031-.625-.805 0-1.462.208-1.969.625a3.24 3.24 0 00-1.052 1.521l1.459.583c.07-.236.215-.503.437-.802.222-.299.583-.448 1.083-.448.43 0 .757.115.98.344.222.23.333.483.333.76 0 .264-.087.521-.26.771-.174.25-.379.472-.615.667-.625.541-1.004.951-1.135 1.229-.132.278-.198.792-.198 1.542zm.791 3.25c.306 0 .563-.104.771-.313.209-.208.313-.465.313-.77 0-.306-.104-.563-.313-.771a1.046 1.046 0 00-.771-.313c-.305 0-.562.104-.77.313a1.046 1.046 0 00-.313.771c0 .305.104.562.313.77.208.209.465.313.77.313z","fill":"#3C80DF"}})])
          )
        }
      }
    